import axios from "axios";

import { BASE_URL, LOGIN_URL } from './common';

export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

export const ME_URL = "api/me"; 
 
export function getInOutHistory() {

  var url = BASE_URL + 'accesshistory?pageSize=10000'; //  + `?loginId=${loginId}&pwd=${pwd}`;

  return axios.get(url);
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
